import { ofetch } from "ofetch"

type SlackPayload = {
  text: string
  blocks?: Array<Record<string, unknown>>
}

export function shouldPublishSlackNotifications(env: { NODE_ENV?: string } = process.env) {
  return env.NODE_ENV === "production"
}

export async function publishSlackNotification(payload: SlackPayload) {
  if (!shouldPublishSlackNotifications()) {
    return { ok: true as const, skipped: "non-production" as const }
  }

  const slackWebhookUrl = process.env.SUBSCRIBE_SLACK_WEBHOOK_URL

  if (!slackWebhookUrl) {
    return { ok: false as const, error: "webhook-not-configured" as const }
  }

  await ofetch(slackWebhookUrl, {
    method: "POST",
    body: payload,
  })

  return { ok: true as const }
}
